export const formatAmount = value => `${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} ${window.Translations.currency}`;
export const isArr = value => Array.isArray(value);
export const getHash = (min, max) => {
    return Math.random() * (max - min) + min;
}
